<template>
  <Layout v-if="wait.is('Loading Docs')">
    <div class="layout__wrapper">
      <loading-spinner />
    </div>
  </Layout>

  <router-view
    v-else-if="docs && lists"
    :docs="docs"
    :lists="lists"
  ></router-view>

  <Layout v-else-if="(!docs || !lists) && wait.is('Error Loading Docs')">
    <div class="layout__wrapper">
      <LoadingError />
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { useRouter } from 'vue-router'
import { backend } from '@/services/backend'
import { CustomListWithDocs, Doc } from '@/models/interfaces'

import Layout from '@/app/components/Layout.vue'

const docs = ref<Doc[] | null>(null)
const lists = ref<CustomListWithDocs[] | null>(null)
const wait = useWait()
const router = useRouter()

onBeforeMount(() => {
  loadDocuments()
})

const loadDocuments = async (): Promise<void> => {
  try {
    wait.start('Loading Docs')
    wait.end('Error Loading Docs')

    docs.value = await backend.getUserDocs()
    lists.value = await backend.getCustomLists()
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      router.push({ name: 'not_found' })
    } else {
      wait.start('Error Loading Docs')
      if (Sentry) {
        Sentry.captureException(error)
      }
    }
  } finally {
    wait.end('Loading Docs')
  }
}
</script>
